<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>名称：</label>
                        <el-input v-model="search_Obj.f_name" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="name" label="厂商名称" sortable="custom"></el-table-column>
                        <el-table-column prop="order_index" label="排序" sortable="custom"></el-table-column>
                        <el-table-column prop="create_time" label="添加时间" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看生产厂商"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'producerList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '生产厂商',
            menu_id: 1020,
            list_url: "/api/admin/producer/list",
            search_Obj: {
                f_xxxname: '',
            },
            del_Obj:{
                url:'/api/admin/producer/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
        };
    },
    methods: {}
};
</script>